import { useOnboardingFiles } from '@/features/onboarding-v2/hooks/useOnboardingFiles';
import { cn } from '@/lib/cn';
import { FileCard } from '@heidi/design-system/file-card';
import { isEmpty } from 'lodash-es';

export const OnboardingFiles = () => {
  const { files, handleRemove } = useOnboardingFiles();

  const hasFiles = !isEmpty(files);

  return (
    <div
      className={cn(
        '-m-2 grid w-full transition-[grid-template-rows]',
        hasFiles ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      )}
    >
      <div className="overflow-hidden">
        <div className="flex w-full gap-1.5 overflow-x-auto p-2">
          {files.map((file) => {
            const isUploading = file.status === 'uploading';
            const isError = file.status === 'error';

            // Extract file extension for fileType display
            const fileExtension = file.name.includes('.')
              ? file.name.split('.').pop()?.toUpperCase()
              : undefined;

            return (
              <FileCard
                key={file.uid}
                variant={isUploading ? 'loading' : 'default'}
                fileName={file.name}
                fileType={fileExtension}
                onDelete={!isUploading ? () => handleRemove(file) : undefined}
                className={cn(isError && 'border-validation-destructive')}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
